import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const tradeVocabulary = api(async function tradeVocabulary({ skillMapId }) {
    return query(
        gql`
            query GetTradeVocabulary($skillMapId: String!) {
                tradeVocabulary(skillMapId: $skillMapId) {
                    tradeId
                    name
                }
            }
        `,
        { skillMapId },
        { returns: "tradeVocabulary" }
    )
})
